import React, { useContext, useState } from 'react'
import { ImgOverlay, ImgViewIcon, InputImg, InputImgContainer, StyledRemoveImg } from './styles'
import { IconX, IconEye } from '@tabler/icons-react'
// @ts-ignore
import { UncontrolledTooltip } from 'reactstrap'
import { ChatbotContext } from './context/ChatbotProvider'
interface ChatImageProps {
  file: any
  onRemoveClick?: any
  size: string
  hasRemove: boolean
}
export const ChatImage: React.FC<ChatImageProps> = ({
  file,
  onRemoveClick = () => null,
  size,
  hasRemove
}) => {
  const { setAttachments } = useContext(ChatbotContext)
  const [isHovered, setIsHovered] = useState(false)
  const onViewClick = (file: any) => {
    setAttachments((prevState: any) => ({
      ...prevState,
      previewFile: file
    }))
  }

  return (
    <InputImgContainer
      $addMargin={hasRemove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-testid="imgContainer">
      {hasRemove ? (
        <>
          <StyledRemoveImg
            onClick={() => onRemoveClick(file.name, 'image')}
            id="remove-img-file"
            data-testid="removeImg"
            className="close-icon">
            <IconX size={20} color="var(--color-secondary)" />
          </StyledRemoveImg>
          <UncontrolledTooltip target={'remove-img-file'}>{'Remove'}</UncontrolledTooltip>
        </>
      ) : (
        isHovered && (
          <ImgOverlay onClick={() => onViewClick(file)} data-testid="imgOverlay">
            <ImgViewIcon data-testid="imgViewIcon">
              <IconEye size={28} color="var(--white)" />
            </ImgViewIcon>
          </ImgOverlay>
        )
      )}
      <InputImg src={file?.content} size={size} />
    </InputImgContainer>
  )
}
